import type React from 'react';

import type { UnpackedFilter } from '../hooks/useMultiFilterEditor';
import { type FilterId, isSegmentedFilter } from '../types/filters';
import { FilterTag } from './FilterTag';
import { SubFilterTag } from './SubFilterTag';

export type FilterWithDisabledState = {
  filter: UnpackedFilter;
  disabled: boolean;
};

interface FilterTagsProps {
  disabled?: boolean;
  filterTags: FilterWithDisabledState[];
  onRemoveFilter: (filterId: FilterId) => void;
  /** The tags are a saved view's preview, not the page's filters. */
  isPreview?: boolean;
}

export const FilterTags: React.FC<FilterTagsProps> = ({
  disabled: externalDisabled,
  filterTags,
  onRemoveFilter,
  isPreview,
}) => {
  // Sort so that disabled filters are always last
  const sortedFilters = filterTags.sort((a, b) => {
    return Number(a.disabled) - Number(b.disabled);
  });

  return (
    <>
      {sortedFilters.map(({ filter, disabled }) => {
        const TagComponent = isSegmentedFilter(filter)
          ? SubFilterTag
          : FilterTag;

        return (
          <TagComponent
            key={filter.displayId || filter.id}
            filter={filter}
            onRemoveFilter={onRemoveFilter}
            disabled={disabled || externalDisabled}
            hideDisabledTooltip={externalDisabled}
            isPreview={isPreview}
          />
        );
      })}
    </>
  );
};
